import { SET_BULK_OPERATION_STATUS } from "../constants/bulkStatusConstants";

const initialState = {
  isBulkOperationInProgress: false,
};

const bulkReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_BULK_OPERATION_STATUS:
      return {
        ...state,
        isBulkOperationInProgress: action.payload,
      };
    default:
      return state;
  }
};

export default bulkReducer;